export default {
  'business-growth': 'Fai crescere il tuo business',
}
